export default __webpack_public_path__ + "static/media/CMS_Charging profile.2326ab4a.svg";